import { UIActionType, UIAction } from '../../actions/uiActions';

type CreateWorkspaceState = {
  creatingWorkspace: boolean;
  organizationId: string;
};

const creatingWorkspaceForOrgReducer = (state = {} as CreateWorkspaceState, action: UIAction) => {
  switch (action.type) {
    case UIActionType.CREATE_WORKSPACE_FOR_ORG:
      return {
        creatingWorkspace: !state.creatingWorkspace,
        organizationId: action.organizationId,
      } as CreateWorkspaceState;
    default:
      return state;
  }
};

export default creatingWorkspaceForOrgReducer;
